import React, { useMemo } from "react";
import { WebsiteBlock } from "../../../cores/websitePage/interfaces/WebsiteBlock";
import {
  HTML_PREVIEW_SANDBOX,
  prepareHtmlPreviewDocument,
  WebsitePageWidgetOptions,
} from "./htmlPreview.utils";
import "./HtmlPageBlock.scss";

interface Props {
  block: WebsiteBlock;
  widgets?: WebsitePageWidgetOptions;
}

export function HtmlPageBlock({ block, widgets }: Props) {
  const previewDoc = useMemo(
    () => prepareHtmlPreviewDocument(block.html || "", widgets),
    [block.html, widgets]
  );

  return (
    <div className="wp-html-page-block">
      <iframe
        title="custom-html-page"
        className="wp-html-page-block__iframe"
        srcDoc={previewDoc}
        sandbox={HTML_PREVIEW_SANDBOX}
      />
    </div>
  );
}
